import React from 'react';

import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from 'src/utils/shadcn';

const squareIconVariants = cva('shadow-xs flex size-10 shrink-0 items-center justify-center rounded-md text-lg', {
    variants: {
        variant: {
            default: 'border border-gray-200 bg-white text-gray-500',
            disabled: 'border border-gray-200 bg-gray-50 text-gray-400',
            destructiveLight: 'border border-red-200 bg-red-50 text-red-500',
            error: 'border border-red-200 bg-white text-red-500',
            warn: 'border border-orange-200 text-orange-500',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

interface SquareIconProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof squareIconVariants> {
    icon?: IconProp;
}

const SquareIcon = ({ icon, children, className, variant, ...props }: SquareIconProps) => {
    return (
        <div className={cn(squareIconVariants({ variant, className }))} {...props}>
            {icon ? <FontAwesomeIcon icon={icon} className="opacity-90" /> : children}
        </div>
    );
};

export default SquareIcon;
